module.exports = __webpack_public_path__ + "img/8.9264489e.jpg";